import { CountryDto } from '@shared/interfaces/dtos/addresses';

/**
 * Default option in countries dropdown.
 *
 * @warn If id changes with environment, it might not work as expected
 */
export const BELGIUM_COUNTRY_DEFAULT_OPTION: CountryDto = {
  id: 21,
  codePays: 'BE',
  description: 'Belgique',
};
